import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useNavigate, Navigate } from "react-router-dom";

import { useDispatch, useSelector } from "react-redux";
import { setAnswer, getUsuario } from "../actions";

import { Container, Row, Col, Button } from "react-bootstrap";

const Equipo = (props) => {
  const dispatch = useDispatch();

  const [values, setValues] = useState({ consentimiento: 0 });

  const [submitted, setSubmitted] = useState(false);

  const usuario = useSelector((state) => state.usuario);

  const HandleClick = (props) => {
    // Guardar Pregunta en Base de Datos
    const _props = {
      Token: "c3649ba4e3a81815",
      Function: "SetSurveyAnswer",
      Parameters: {
        Id: 0,
        CreationDateTime: "",
        UserId: parseInt(usuario.UserId.split("-")[0]),
        SurveyId: 110,
        QuestionId: 11001,
        Answer: 1,
        Value: 0,
      },
    };

    dispatch(setAnswer(_props));
    //
    setValues((values) => ({
      ...values,
      consentimiento: 1,
    }));
  };

  //console.log("Render", usuario, values);

  if (values.consentimiento === 1)
    return <Navigate to="/inicio" replace="true" />;

  return (
    <Container>
      <h3 className="mt-4">Welcome to Darwin platform</h3>
      <Row className="m-sm-5">
        <Col className="xz-texto-instr">
          <p className=" ">
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim
            ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut
            aliquip ex ea commodo consequat. Duis aute irure dolor in
            reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla
            pariatur. Excepteur sint occaecat cupidatat non proident, sunt in
            culpa qui officia deserunt mollit anim id est laborum.
          </p>
        </Col>
      </Row>

      <Row className="mt-2">
        <Col className="text-center">
          {" "}
          <Button className="xz-btn-ok" onClick={HandleClick.bind(this)}>
            Continuar
          </Button>
        </Col>
      </Row>
      <Row className="mt-4">
        <Col className="text-center">
          <p className="">
            Sed ut perspiciatis unde omnis iste natus error sit voluptatem
            accusantium doloremque laudantium{" "}
          </p>
          <p className="">
            ut enim ad minima veniam, quis nostrum exercitationem ullam
            corporis.{" "}
          </p>
        </Col>
      </Row>
    </Container>
  );
};

export default Equipo;
